"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AllowedCharacters = exports.FileInputTypes = exports.FileInputErrors = exports.Language = exports.OutlinedIconInputTopPadding = exports.OutlinedIconInputSidePadding = exports.LabelBottomMargin = exports.InputPadding = exports.InputMobileHeight = exports.InputHeight = void 0;
var InputHeight;

(function (InputHeight) {
  InputHeight["sm"] = "30px";
  InputHeight["md"] = "40px";
  InputHeight["lg"] = "60px";
  InputHeight["xl"] = "80px";
})(InputHeight || (exports.InputHeight = InputHeight = {}));

var InputMobileHeight;

(function (InputMobileHeight) {
  InputMobileHeight["sm"] = "30px";
  InputMobileHeight["md"] = "40px";
  InputMobileHeight["lg"] = "50px";
  InputMobileHeight["xl"] = "50px";
})(InputMobileHeight || (exports.InputMobileHeight = InputMobileHeight = {}));

var InputPadding;

(function (InputPadding) {
  InputPadding["sm"] = "10px";
  InputPadding["md"] = "20px";
  InputPadding["lg"] = "20px";
  InputPadding["xl"] = "30px";
})(InputPadding || (exports.InputPadding = InputPadding = {}));

var LabelBottomMargin;

(function (LabelBottomMargin) {
  LabelBottomMargin["sm"] = "7px";
  LabelBottomMargin["md"] = "9px";
  LabelBottomMargin["lg"] = "9px";
  LabelBottomMargin["xl"] = "14px";
})(LabelBottomMargin || (exports.LabelBottomMargin = LabelBottomMargin = {}));

var OutlinedIconInputSidePadding;

(function (OutlinedIconInputSidePadding) {
  OutlinedIconInputSidePadding["sm"] = "5px";
  OutlinedIconInputSidePadding["md"] = "10px";
  OutlinedIconInputSidePadding["lg"] = "10px";
  OutlinedIconInputSidePadding["xl"] = "16px";
})(OutlinedIconInputSidePadding || (exports.OutlinedIconInputSidePadding = OutlinedIconInputSidePadding = {}));

var OutlinedIconInputTopPadding;

(function (OutlinedIconInputTopPadding) {
  OutlinedIconInputTopPadding["sm"] = "-11px";
  OutlinedIconInputTopPadding["md"] = "-17px";
  OutlinedIconInputTopPadding["lg"] = "-17px";
  OutlinedIconInputTopPadding["xl"] = "-17px";
})(OutlinedIconInputTopPadding || (exports.OutlinedIconInputTopPadding = OutlinedIconInputTopPadding = {}));

var Language;

(function (Language) {
  Language["en"] = "en";
  Language["fr"] = "fr";
  Language["es"] = "es";
})(Language || (exports.Language = Language = {}));

var FileInputErrors;

(function (FileInputErrors) {
  FileInputErrors["FILETYPE"] = "invalidFileType";
  FileInputErrors["MIN"] = "minFiles";
  FileInputErrors["MAX"] = "maxFiles";
  FileInputErrors["SIZE"] = "maxSize";
  FileInputErrors["REQUIRED"] = "required";
  FileInputErrors["PARTIALMAX"] = "partialMax";
})(FileInputErrors || (exports.FileInputErrors = FileInputErrors = {}));

var FileInputTypes;

(function (FileInputTypes) {
  FileInputTypes["PNG"] = "png";
  FileInputTypes["JPG"] = "jpg";
  FileInputTypes["JPEG"] = "jpeg";
  FileInputTypes["TIFF"] = "tiff";
  FileInputTypes["HEIC"] = "heic";
  FileInputTypes["PDF"] = "pdf";
  FileInputTypes["DOC"] = "doc";
  FileInputTypes["DOCX"] = "docx";
  FileInputTypes["CSV"] = "csv";
  FileInputTypes["XLS"] = "xls";
  FileInputTypes["XLSX"] = "xlsx";
  FileInputTypes["PPT"] = "ppt";
  FileInputTypes["PPTX"] = "pptx";
  FileInputTypes["MP3"] = "mp3";
  FileInputTypes["WAV"] = "wav";
  FileInputTypes["AAC"] = "aac";
  FileInputTypes["MOV"] = "mov";
  FileInputTypes["M4P"] = "m4p";
  FileInputTypes["MPEG"] = "mpeg";
  FileInputTypes["MKV"] = "mkv";
  FileInputTypes["GIF"] = "gif";
  FileInputTypes["ODT"] = "odt";
  FileInputTypes["ODS"] = "ods";
  FileInputTypes["ODP"] = "odp";
  FileInputTypes["RTF"] = "rtf";
  FileInputTypes["TXT"] = "txt";
})(FileInputTypes || (exports.FileInputTypes = FileInputTypes = {}));

var AllowedCharacters;

(function (AllowedCharacters) {
  AllowedCharacters["NumbersOnly"] = "^[0-9]*$";
  AllowedCharacters["Numeric"] = "^[0-9\\.\\-]*$";
  AllowedCharacters["AlphaOnly"] = "^[a-zA-Z]*$";
})(AllowedCharacters || (exports.AllowedCharacters = AllowedCharacters = {}));